import Button from './Button';

const DeleteButton = {
    extends : Button,
    props   : {
        text   : { type : String, default : 'Delete' },
        color  : { type : String, default : 'danger' },
        icon   : { type : String, default : 'fa fa-trash' },
        design : { type : String, default : 'basic-b' },
        size   : { type : String, default : 'xs' }
    }
};

export default DeleteButton;
